import { GameState } from './index'

export function isBoosterActive(gameState: GameState): boolean {
    return gameState.boosterEndsAt > Date.now()
}

export function getBoosterProgress(gameState: GameState): number {
    return Date.now() / gameState.boosterEndsAt
}
